import { render } from "./EmbedHelpModal.vue?vue&type=template&id=5333a2eb"
import script from "./EmbedHelpModal.vue?vue&type=script&lang=js"
export * from "./EmbedHelpModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__